import React from 'react';
import './Rocket.css'
import rocket from '../../../../src/assets/images/rocket.png'
const Rocket = () => {
    return (
        <div className="rocket">
            <img className="img-fluid my-2" style={{width:"110px"}} src={rocket} alt="rocket" />
        </div>
    );
};

export default Rocket;